export const validationMessages = {
  required: 'Обязательное поле',
  invalidFormat: 'Неправильный формат',
}